import { UnitSystem } from 'shared/src/context/MeasurementContext'
import type { NoneUnit } from 'shared/src/model/common'
import { DistanceUnit, Unit, Unit as UnitEnum, VolumeUnit } from 'shared/src/model/common'
import { T } from 'shared/src/util/translation'

export const US_CUSTOMARY_CONTEXT = {
  currentUnitSystemType: UnitSystem.US_CUSTOMARY,
  selectedUnits: {
    distance: DistanceUnit.INCH,
    volume: VolumeUnit.GALLON_LIQUID_US,
  },
}

export const METRIC_CONTEXT = {
  currentUnitSystemType: UnitSystem.METRIC,
  selectedUnits: {
    distance: DistanceUnit.CENTIMETER,
    volume: VolumeUnit.LITER,
  },
}

export const getTranslationStringForUnit = (unit: Unit | DistanceUnit | VolumeUnit | NoneUnit): string => {
  switch (unit) {
    case Unit.INCH:
      return T('inch_abbr')
    default:
      return `${unit}`
  }
}

export const getDefaultNumberFormatOptions = (
  unit: Unit | DistanceUnit | VolumeUnit | NoneUnit,
): Intl.NumberFormatOptions | undefined => {
  switch (unit) {
    case UnitEnum.CELSIUS:
      return { maximumFractionDigits: 1, minimumFractionDigits: 1 }
    case UnitEnum.CENTIMETER:
      return { maximumFractionDigits: 1 }
    case UnitEnum.INCH:
      return { maximumFractionDigits: 2, minimumFractionDigits: 0 }
    case UnitEnum.KILOGRAM:
      return { maximumFractionDigits: 0 }
    case UnitEnum.LITER:
      return { maximumFractionDigits: 0 }
    case UnitEnum.METER:
      return { maximumFractionDigits: 0 }
    case UnitEnum.KILOMETER:
      return { maximumFractionDigits: 1 }
    case UnitEnum.MILLIMETER:
      return { maximumFractionDigits: 0 }
    case UnitEnum.PASCAL:
      return { maximumFractionDigits: 2, minimumFractionDigits: 2 }
    case UnitEnum.PERCENT:
      return { maximumFractionDigits: 1 }
    case UnitEnum.GALLON_LIQUID_US:
      return { maximumFractionDigits: 1, minimumFractionDigits: 0 }
    case UnitEnum.NONE:
    default:
      return undefined
  }
}
